import axios from 'axios'

const accountingSeatReject =  async function(id){
    try{
        const   path = `/acc_accounting_seat/${id}/reject`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export { accountingSeatReject }
